export function html(strings, ...exprs) {
    return strings.reduce((out, str, i) => out + str + (exprs[i] ?? ''), '');
}
